import { PAReviewModule } from "@/store/modules/paReview.module";
import { assign, Machine } from "xstate";
const commentMachine = Machine({
    id: "commentMachine",
    context: {
        commentText: "",
        commentCreated: false,
        operationMode: "",
        isNewComment: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                INITIALIZE: {
                    target: "initialize",
                    actions: assign((context, event) => {
                        return { commentText: event.commentText, isNewComment: event.isNewComment };
                    }),
                },
            },
        },
        initialize: {
            always: [
                { target: "uncommented", cond: (context, event) => context.commentText === "" },
                { target: "commentSaved", cond: (context, event) => context.commentText !== "" },
            ],
        },
        uncommented: {
            on: {
                SHOW_COMMENTING_BOX: "writingComment",
            },
        },
        writingComment: {
            tags: "savingComment",
            on: {
                SAVE_COMMENT: { target: "savingComment" },
                CANCEL_COMMENTING_BOX: "uncommented",
            },
        },
        savingComment: {
            tags: "savingComment",
            invoke: {
                id: "savingComment",
                src: (ctx, event) => {
                    return PAReviewModule.SaveReviewComment(event.comment);
                },
                onDone: [
                    {
                        target: "commentSaved",
                        cond: (context, event) => !context.isNewComment,
                        actions: assign((context, event) => {
                            return { commentText: event.data.commentText };
                        }),
                    },
                    {
                        target: "uncommented",
                        cond: (context, event) => context.isNewComment,
                        actions: assign((context, event) => {
                            return { commentText: "" };
                        }),
                    },
                ],
                onError: {
                    target: "commentSaveFailed",
                },
            },
        },
        commentSaved: {
            tags: "showingComment",
            on: {
                SHOW_COMMENTING_BOX: "editingComment",
                DELETE_COMMENT: "deletingComment",
                RE_INITIALIZE: { target: "initialize", actions: assign((context, event) => ({ commentText: event.commentText })) },
            },
        },
        editingComment: {
            tags: "savingComment",
            on: {
                SAVE_COMMENT: "savingComment",
                CANCEL_COMMENTING_BOX: "commentSaved",
            },
        },
        commentSaveFailed: {
            type: "final",
        },
        deletingComment: {
            tags: "showingComment",
            invoke: {
                id: "deletingComment",
                src: (ctx, event) => {
                    return PAReviewModule.DeleteReviewComment(event.commentId);
                },
                onDone: {
                    target: "commentDestroyed",
                    actions: ["deleteComment"],
                },
                onError: {
                    target: "commentSaved",
                },
            },
        },
        commentDestroyed: {},
    },
}, {
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
    },
    actions: {},
    guards: {},
    activities: {},
});
export default commentMachine;
